<main class="flex overflow-hidden flex-col w-screen h-dvh bg-primary">
    <app-header />
    <div
        class="flex overflow-hidden overflow-x-hidden overflow-y-scroll flex-col pb-14 bg-white rounded-t-2xl size-full basis-full grow-0"
    >
        <router-outlet />
    </div>

    @if (!layoutStore.isShowPageModal$()) {
    <app-footer class="w-full" />
    }
</main>
